import axios from "axios";
import config from "../config/config";

const axiosInstance = axios.create({
  baseURL: config.backendUrl,
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear token in storage to trigger multi-tab sync and reset session
      localStorage.removeItem("userToken");
      localStorage.removeItem("visitor_id");
      // Trigger a storage event locally or window reload to reset unauthenticated state
      window.dispatchEvent(new Event("storage"));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
